import React from 'react';
import {
  Button,
  HeadingText,
  HeadingBar,
  Modal,
  StackLayout,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';

interface Props {
  children: React.ReactNode;
  footer?: React.ReactNode;
  title?: string;
  maxWidth?: number;
  closeDisabled?: boolean;
}

export const BaseModalContainer = ({
  title,
  maxWidth = 580,
  children,
  footer = null,
  closeDisabled,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Modal.Content
      showCloseButton={false}
      padding="$none"
      onInteractOutside={closeDisabled ? (e) => e.preventDefault() : undefined}
      onEscapeKeyDown={closeDisabled ? (e) => e.preventDefault() : undefined}
      css={{
        '.GDS-modal': {
          width: maxWidth,
          height: 'auto',
          maxWidth,
          '@mobile': {
            width: '100%',
            maxWidth: '100%',
          },
        },
      }}
    >
      <HeadingBar
        trailingAction={
          <Modal.Close asChild>
            <Button
              priority="tertiary"
              icon="tinyClose"
              size="small"
              hideLabel
              css={{ border: 'none' }}
              disabled={closeDisabled}
            >
              {formatMessage({ id: 'STR_CLOSE' })}
            </Button>
          </Modal.Close>
        }
        title={
          title ? (
            <Modal.Title asChild>
              <HeadingText level="display" size="sm">
                {title}
              </HeadingText>
            </Modal.Title>
          ) : null
        }
      />
      <StackLayout
        horizontalAlignment="stretch"
        css={{
          height: 'auto',
          padding: '$oneAndHalf',
          paddingTop: '$none',
          textAlign: 'left',
          '@mobile': { textAlign: 'center' },
        }}
      >
        {children}
        {footer && (
          <StackLayout horizontalAlignment="stretch" css={{ width: '100%' }}>
            {footer}
          </StackLayout>
        )}
      </StackLayout>
    </Modal.Content>
  );
};
